import classNames from 'classnames';
import {type FC, useState} from 'react';
import {EditButton} from './EditButton';

type Props = {
  index: number;
  qaId: number;
  options: Array<{
    id: number;
    choice: string;
  }>;
  selectedOptions: string[];
  setThemeId: (id: number) => void;
  handleSelectOption: (value: string, index?: number) => void;
  updateEditingState: (index: number, isEditing: boolean) => void;
};

export const SelectChoiceContent: FC<Props> = ({
  index,
  qaId,
  options,
  selectedOptions,
  setThemeId,
  handleSelectOption,
  updateEditingState,
}) => {
  // 表示用：編集中は表示のみクリアするが、選択は保持する
  const [displaySelectedId, setDisplaySelectedId] = useState<
    number | undefined
  >(undefined);
  const [selectedId, setSelectedId] = useState<number | undefined>(undefined);
  const [editing, setEditing] = useState(false);
  // テーマ判定
  const isTheme = qaId === 0;
  // 現在のステップかどうか
  const isCurrentStep = index === selectedOptions.length;
  // 編集中もしくは現在のステップかどうか
  const isClickable = isCurrentStep || editing;

  const handleOptionClick = (optionId: number, choice: string) => {
    if (isClickable) {
      if (isTheme) {
        setThemeId(optionId);
      }

      setDisplaySelectedId(optionId);
      setSelectedId(optionId);

      if (editing) {
        handleSelectOption(choice, index);
        setEditing(false);
        updateEditingState(index, false);
      } else {
        handleSelectOption(choice);
      }
    }
  };

  return (
    <div
      id={`ai-es-builder-question-${index}`}
      className="flex gap-8 justify-start items-end"
    >
      {!isCurrentStep && !isTheme && (
        <EditButton
          editing={editing}
          editClick={() => {
            setEditing(!editing);
            if (editing) {
              setDisplaySelectedId(selectedId);
            } else {
              setDisplaySelectedId(undefined);
            }

            updateEditingState(index, !editing);
          }}
        />
      )}
      <div className="flex flex-col gap-8 max-w-3/4 pc:max-w-1/2">
        {options?.map((option) => (
          <button
            key={option.id}
            type="button"
            className={classNames(
              'bg-gradient-to-r from-gradient-ai-l to-gradient-ai-r rounded-full p-[2px]',
              'enabled:cursor-pointer enabled:hover:opacity-60',
              'disabled:cursor-not-allowed',
            )}
            onClick={() => {
              handleOptionClick(option.id, option.choice);
            }}
            disabled={!isClickable}
          >
            <div
              className={classNames(
                'rounded-full px-16 py-8 flex justify-start',
                {
                  '': displaySelectedId === option.id,
                  'bg-white': displaySelectedId !== option.id,
                },
              )}
            >
              <div
                className={classNames('text-base', {
                  'text-white': displaySelectedId === option.id,
                  'bg-gradient-to-r from-gradient-ai-l to-gradient-ai-r text-transparent bg-clip-text':
                    displaySelectedId !== option.id,
                })}
              >
                {option.choice}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
